import { useRouter } from 'next/router';

import { useIsOnReviewStep, useMultiplexDetails, useMultiplexListingFlow } from '../../../hooks/queries/multiplex';
import { useGetListingDetails } from '../../../hooks/queries/properties';
import { getIsInputFormDisabled } from '../../MFAccordion/utils';

import { useAuth } from '../../AuthProvider';
import AdditionalAmenities from './AdditionalAmenities';

const label = 'Additional amenities';

type Props = { isRelistingFieldset?: boolean };

const AddAmenitiesFormField = ({ isRelistingFieldset }: Props) => {
  const router = useRouter();
  const { user } = useAuth();

  const listingAlias = router.query.listingAlias as string;
  const { data: listingDetails } = useGetListingDetails(listingAlias);

  const isOnReviewStep = useIsOnReviewStep();
  const { data: multiplexData } = useMultiplexDetails({ enabled: !isOnReviewStep });
  const { isInMultiplexListingFlow } = useMultiplexListingFlow();
  const isMultiplexFlowActive = Boolean(isInMultiplexListingFlow);

  const propertyAmenitiesFromListing = listingDetails?.propertyAmenities ?? [];
  const multiplexAdditionalAmenities = multiplexData?.amenities?.additional;

  const propertyAmenities =
    !isMultiplexFlowActive || isOnReviewStep ? propertyAmenitiesFromListing : (multiplexAdditionalAmenities ?? []);

  const canUpdateListing = user?.features?.canUpdateListing ?? false;
  const isFeed = listingDetails?.isFeed || false;
  const isPropertyAmenitiesUpdateRestricted =
    listingDetails?.restrictions?.isPropertyAmenitiesUpdateRestricted || false;

  const isInputFormDisabled = getIsInputFormDisabled(listingDetails, canUpdateListing);
  const labelSize = isRelistingFieldset ? 'lg' : 'md';

  return (
    <div data-testid="AddAmenitiesFormField">
      <AdditionalAmenities
        listingAlias={listingAlias}
        previouslySavedAmenities={propertyAmenities}
        isInputFormDisabled={isInputFormDisabled}
        isFeed={isFeed}
        isPropertyAmenitiesUpdateRestricted={isPropertyAmenitiesUpdateRestricted}
        label={label}
        labelSize={labelSize}
      />
    </div>
  );
};

export default AddAmenitiesFormField;
